import { Component, OnInit, Inject } from '@angular/core';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { TranslateService } from '@ngstack/translate';
import { ErrorsService } from 'src/app/services/common/errors.service';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { DiscountGroupPersonEntryComponent } from 'src/app/pages/finance/discount-group-person/discount-group-person-entry/discount-group-person-entry.component';
import { ExceptionalCoefficientsService } from 'src/app/services/http/business/ExceptionalCoefficients/exceptional-coefficients.service';
import { SnackBarService } from 'src/app/services/common/snackBar.service';
import { SoundEnum } from 'src/app/enums/sound.enum';
import * as moment from "jalali-moment";
import { environment } from 'src/environments/environment';
import { IConfirm } from 'src/app/interfaces/confirm';
import { ConfirmComponent } from 'src/app/components/confirm/confirm.component';
import { IError } from 'src/app/interfaces/error.interface';
@Component({
  selector: 'app-set-session-coefficient',
  templateUrl: './set-session-coefficient.component.html',
  styleUrls: ['./set-session-coefficient.component.css']
})
export class SetSessionCoefficientComponent implements OnInit {
  param: any;
  errorList: IError[] = [];
  errObject: any;
  form: FormGroup;
  errors = new Array();

  constructor(
    private fb: FormBuilder,
    public translate: TranslateService,
    private errorService: ErrorsService,
    private dialog: MatDialog,
    private snackBar: SnackBarService,
    public dialogRef: MatDialogRef<DiscountGroupPersonEntryComponent>,
    private exceptionalCoefficientsService: ExceptionalCoefficientsService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    console.log(this.data);
    this.createForm();
  }

  createForm() {
    this.form = this.fb.group({
      Id: [this.data.Id, Validators.required],
      FromDate: [null, Validators.required],
      ToDate: [null, Validators.required],
    });
    if (this.data) {
      if (this.data.Id) this.form.controls.Id.setValue(this.data.Id)
    }
  }
  submit(form: any) {
    let confirm: IConfirm = {
      accept: true,
      message: 'آیا از تغییر ضریب جلسات اطمینان دارید؟',
      alert: null,
      yesLabel: this.translate.get("label.yes"),
      noLabel: this.translate.get("label.no")
    };
    this.dialog.open(ConfirmComponent, {
      width: "300px",
      data: confirm
    })
      .afterClosed()
      .subscribe(
        res => {
          if (res) {
            this.errors = new Array();
            form.FromDate = moment
              .from(form.FromDate, "en")
              .utc(true)
              .format(environment.dateFormat);
            form.ToDate = moment
              .from(form.ToDate, "en")
              .utc(true)
              .format(environment.dateFormat);
            this.exceptionalCoefficientsService.setCoefficientAfterTime(form).subscribe(ret => {
              if (ret.returnValue > 0) {
                this.snackBar.OpenSnackBar(
                  'ضرایب ' + ret.returnValue + ' جلسه با موفقیت ویرایش شد',
                  "ok",
                  5000,
                  SoundEnum.beep
                );
                this.dialogRef.close();
              }
              if (ret.returnValue == 0)
                this.snackBar.OpenSnackBar(
                  'جلسه ایی برای تغییر ضریب یافت نشد',
                  "ok",
                  5000,
                  SoundEnum.beep
                );
            },
              err => {
                // this.errObject = this.errorService.getError(err);
                // this.param = this.errorService.objectError(this.errObject);
                // this.errors = this.errorService.returnError(err);
                this.errorList = this.errorService.getErrorList(err.error);
              }
            );
          }
        })
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
  
}
